import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Eye, FileArrowDown } from "@phosphor-icons/react";
import { SuiteBadge } from "@/components/projects/SuiteBadge";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "-");

export const ProjectsGridView = ({ projects, onOpen, onBrief }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="projects-grid">
    {projects.map((p) => (
      <Card key={p.id} data-testid={`project-gcard-${p.id}`} onClick={() => onOpen(p)}
        className="p-5 shadow-none cursor-pointer hover:border-primary transition-colors group">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-1.5 flex-wrap">
            <Badge variant="secondary" className="font-mono text-[10px]">{p.commodity || "Project"}</Badge>
            <SuiteBadge commodity={p.commodity} id={p.id} hms={p.hms} />
          </div>
          <Badge variant="outline">{p.status}</Badge>
        </div>
        <h3 className="font-display text-lg font-bold mt-3 group-hover:text-primary transition-colors truncate">{p.name}</h3>
        <div className="text-xs text-muted-foreground mt-1 truncate">
          {p.project_number && <span className="font-mono">{p.project_number} · </span>}
          {p.client_name || "Unassigned"}{p.country ? ` · ${p.country}` : ""}
        </div>
        <div className="mt-4 pt-3 border-t border-border flex items-center justify-between gap-2 text-xs text-muted-foreground font-mono">
          <span>{fmtDate(p.updated_at)}</span>
          <div className="flex items-center gap-2">
            {(p.shared || p.share_views > 0) && (
              <span data-testid={`project-gviews-${p.id}`} title="Client teaser opens"
                className="inline-flex items-center gap-1 rounded-full bg-orange-50 text-orange-700 border border-orange-200 px-1.5 py-0.5 text-[10px] font-semibold not-italic">
                <Eye size={11} /> {p.share_views || 0} {p.share_views === 1 ? "open" : "opens"}
              </span>
            )}
            <button data-testid={`gbrief-${p.id}`} title="Download Command Brief (1-page technical PDF)"
              onClick={(e) => { e.stopPropagation(); onBrief(p); }}
              className="inline-flex items-center gap-1 rounded-md border border-border px-2 h-6 text-[10px] font-semibold text-muted-foreground hover:border-primary/60 hover:text-primary transition-colors not-italic">
              <FileArrowDown size={12} /> Brief
            </button>
          </div>
        </div>
      </Card>
    ))}
  </div>
);
